<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';

</script>

<PageHeader title={titlePage}></PageHeader> 
<div class="container clearfix text-justify">

	<p>Confira a documentação solicitada para locação:</p>
	
	<div class="gridbox size--1 md-size--1">

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-user"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">Locatário(a)</h2>
				<ul class="list-cycle">
					<li>Cópia RG e CPF;</li>
					<li>Cópia comprovante de renda ou declaração do imposto de renda;</li>
					<li>Comprovante de residência (água, luz ou telefone);</li>
					<li>Ficha Cadastral Preenchida e Assinada - 
					<a href="/fichas-cadastrais"><strong>Clique aqui para acessar</strong></a></li>
				</ul>
			</div>
		</div>

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-user-shield"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">Fiador(a)</h2>
				<ul class="list-cycle">
					<li>Cópia de matrícula atualizada do(s) imóvel(is) ou certidão negativa de ônus;</li>
					<li>Cópia RG e CPF;</li>
					<li>Cópia comprovante de renda ou declaração do imposto de renda;</li>
					<li>Comprovante de residência (água, luz ou telefone);</li>
					<li>Ficha Cadastral Preenchida e Assinada - 
					<a href="/fichas-cadastrais"><strong>Clique aqui para acessar</strong></a></li>
					<li><strong>Observação:</strong> Se casado(a) a documentação deverá ser do casal;</li>
				</ul>
			</div>
		</div>

	</div>

	<hr>
	<div class="button mt-40 text-center">        
		<a href="/garantias-locaticias" use:link replace title="" class="btn btn-secondary">
			Confira as garantias locatícias <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>

</div>

<style type="text/sass">

.card-border
	padding: 20px
	display: flex
	align-items: center
	flex-direction: column
	h2
		font-size: 16px
	p 
		font-size: 12px
		line-height: 120%

</style>